import "core-js/modules/es6.regexp.flags.js";
export function SET_FLAGS(state, data) {
  state.flags = data;
}